import { useRef } from 'react';
import TabbedPanel, { TabDefinition } from 'toolkit/tabs/tabbedPanel';
import SyvaNeeds from '../needs/syva-needs';
import MemberInfo from './MemberInfo';
import { useAppSelector } from 'redux/store-hooks';
import { Box, Typography } from '@mui/material';
import styled from 'styled-components';
import { IconLibrary } from '@act/storybook';

const DivWithHeight = styled.div`
  height: 100%;
`;

export default function MemberProfile() {
  const ref = useRef(null);
  const selectedMemberId = useAppSelector(
    state => state.selectedMember.memberId
  );

  if (selectedMemberId) {
    const tabDefinitions: TabDefinition[] = [
      {
        key: 'member-info',
        label: (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconLibrary iconName="UserList" />
            <Typography variant="titleMedium">Member info</Typography>
          </Box>
        ),
        component: <MemberInfo />,
      },
      {
        key: 'needs',
        label: (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconLibrary iconName="HandHeart" />
            <Typography variant="titleMedium">Needs</Typography>
          </Box>
        ),
        component: <SyvaNeeds />,
      },
    ];

    return (
      <DivWithHeight ref={ref}>
        <TabbedPanel tabDefinitions={tabDefinitions} />
      </DivWithHeight>
    );
  }
}
